<template>
    <div class="flex min-h-full flex-1 flex-col justify-start px-6 py-12 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <h2 class="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Sign in to your account</h2>
        </div>

        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form class="space-y-6" action="#" method="POST" @submit.prevent="submitForm">
                <div>
                    <div class="mt-2">
                        <FloatLabel variant="in" class="w-full">
                            <InputText :invalid="!!errors.verificationCode" id="verificationCode" v-model="verificationCode" variant="filled" class="w-full" type="text" />
                            <label for="verificationCode">Verification Code</label>
                        </FloatLabel>
                    </div>
                </div>

                <div class="flex items-center justify-between">
                    <div class="text-sm">
                        <a href="#" class="font-semibold text-emerald-600 hover:text-emerald-500" @click.prevent="sendAgain">Send Again</a>
                        <span v-if="errors.general || errors.verificationCode" class="text-red-600 block mt-1">{{ errors.general[0] }}</span>
                        <span v-if="success.message" class="text-emerald-600 block mt-1">{{ success.message }}</span>
                    </div>
                </div>

                <div>
                    <Button class="w-full" type="submit" variant="primary" :loading="loading">
                        Verify Email
                    </Button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import InputText from 'primevue/inputtext';
import FloatLabel from 'primevue/floatlabel';
import Button from 'primevue/button';
import { ref } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { useRouter } from 'vue-router';

const verificationCode = ref('');
const loading = ref(false);
const errors = ref({});
const success = ref({});
const route = useRouter();
const email = localStorage.getItem('verify-email');

const submitForm = () => {
    loading.value = true;

    useAuth()
        .verifyEmail(verificationCode.value, email)
        .then(() => {
            success.value = { message: 'Email verified successfully.' };
            localStorage.removeItem('verify-email');
            route.push({ name: 'home', query: { verified: 'true' } });
        })
        .catch((error) => {
            if (error.response?.status === 422) {
                errors.value = error.response.data.errors;
            } else {
                errors.value = { general: [error.response?.data?.message] } ?? { general: ['An error occurred during verification.'] };
            }
        })
        .finally(() => {
            loading.value = false;
        });
};

const sendAgain = () => {
    useAuth()
        .resendVerificationEmail(email)
        .then(() => {
            success.value = { message: 'Verification email resent successfully.' };
            // hide success message after 5 seconds
            setTimeout(() => {
                success.value = {};
            }, 5000);
        })
        .catch((error) => {
            errors.value = { general: [error.response?.data?.message] } ?? { general: ['An error occurred while resending the verification email.'] };
        });
};
</script>